import React, { useEffect } from "react"
import styled from "@emotion/styled"
import popupHelper from "@nutrafol/popup-helper"

import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"
import CloseIcon from "../../../../assets/icons/close-x-icon.svg"

const ModalBody = styled.div`
  @media (min-width: 768px) {
    img {
      border-radius: 12px;
    }
  }
`

const CloseWrapper = styled.button`
  background: ${theme.wild.color.master.base.default};
  border-radius: 50%;
  height: 36px;
  width: 36px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05), 0 24px 38px rgba(0, 0, 0, 0.03), 0 9px 46px rgba(0, 0, 0, 0.03), 0 11px 15px rgba(0, 0, 0, 0.03);
  top: 16px;
  right: 16px;
  position: fixed;
  z-index: 15;
  @media (min-width: 768px) {
    top: 32px;
    right: 32px;
  }
  svg {
    display: block;
    margin: 0 auto;
    height: 10px;
    width: 10px;
  }
`

export const ModalWildImageDesk = (props) => {

  const Component = props.component
  const { hideModal, propsObject, modalSize, customZIndex} = props
  const zIndex = customZIndex ? customZIndex : 15

  const ModalOverlay = styled.div`
    position: fixed;
    z-index: ${zIndex};
    background: rgba(0, 87, 82, .2);
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  `
  const ModalWrap = styled.div`
    position: fixed;
    z-index: ${zIndex + 1};
    left: 16px;
    top: 64px;
    width: calc(100% - 32px);
    height: auto;
    background: transparent;
    overflow: auto;
    @media (min-width: 768px) {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 53%;
      max-width: 1098px;
      height: auto; 
      max-height: 98vh; 
      border-radius: 0;
      box-shadow: 0 80px 67px rgba(13, 98, 92, 0.07), 0 30px 30px rgba(13, 98, 92, 0.05);
    }
    @media (min-width: 1100px) {
      width: 50%;
    }
    @media (min-width: 1300px) {
      width: 35%;
    }
    @media (min-width: 1600px) {
      width: 30%;
    }
  `

  const hideModalProxy = () => {
    popupHelper.onClose()
    hideModal()
  }

  useEffect(() => {
    popupHelper.onOpen({
      wrapper: "Modal",
      desktopEl: "ModalBody",
      mobileEl: "ModalBody",
      closeEl: "CloseWrapper"
    })
    popupHelper.disableScroll()
  }, [])

  useEffect(() => {
    const onresize = () => {
      try {
        if(window.innerWidth < 768) {
          popupHelper.onClose()
          hideModal()
        }
      } catch (e) {
        //error
      }
    }
    window.addEventListener("resize", onresize)
  }, [hideModal])

  return (
    <>
      <ModalOverlay onClick={hideModalProxy} />
      <CloseWrapper id={`CloseWrapper`} onClick={hideModalProxy} >
        <CloseIcon/>
      </CloseWrapper>
      <ModalWrap id={`Modal`} className={modalSize ? modalSize : ''}>
        <ModalBody id={`ModalBody`}>
          <Component {...propsObject}  hideModal={hideModalProxy}/>
        </ModalBody>
      </ModalWrap>
    </>
  )
}

export default ModalWildImageDesk
